// extracted by mini-css-extract-plugin
export var dataCell = "_m0-2";
export var dataRow = "_m0-0";
export var headerRow = "_m0-1";